import { AbstractControl, ValidationErrors } from '@angular/forms';

export function dateRangeValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) return null;

  const value = control.value;
  const parts = value.split('/');
  if (parts.length !== 3) return { invalidDate: true };

  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10);
  const year = parseInt(parts[2], 10);

  const currentYear = new Date().getFullYear();

  if (year < 1900 || year > currentYear) {
    return { yearOutOfRange: true };
  }

  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return { nonexistentDate: true };
  }

  const today = new Date();
  let age = today.getFullYear() - year;

  const birthdayThisYear = new Date(today.getFullYear(), month - 1, day);
  if (today < birthdayThisYear) {
    age--;
  }

  if (age < 18) {
    return { underAge: true };
  }

  return null;
}
